import React from "react";

export default function StudentDetailNotesSection({ notes }) {
  return (
    <div className="w-full mb-8">
      <h3 className="text-xl font-bold text-gray-900 mb-4 px-1">메모</h3>
      <div className="bg-[#FFF9E5] p-6 rounded-3xl text-gray-800 font-medium leading-relaxed shadow-sm">
        {notes || "특이사항이 없습니다."}
      </div>
    </div>
  );
}
